// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-page-wrapper {
    min-height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: var(--bg-page);
    background-size: cover;
    padding: 30px 20px 40px;
}

.auth-card.register-card {
    max-width: 500px;
}

.register-header {
    text-align: center;
    margin-bottom: 24px;
}

.register-header h2 {
    font-size: 1.75rem;
    font-weight: 800;
    color: var(--text-main);
    margin: 0 0 8px 0;
}

.register-header p {
    color: var(--text-muted);
    font-size: 0.95rem;
}

.register-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.name-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

input[type="email"] {
    text-transform: lowercase;
}

@media (max-width: 480px) {
    .name-row {
        grid-template-columns: 1fr;
    }
}

.form-group input,
.form-group select {
    width: 100%;
    height: 52px;
    padding: 0 16px;
    background-color: var(--bg-input);
    border: 1px solid var(--border-light);
    border-radius: var(--radius-input);
    font-size: 1rem;
    color: var(--text-main);
    transition: var(--transition);
    box-sizing: border-box;
    appearance: none;
}

.form-group input:focus,
.form-group select:focus {
    outline: none;
    background-color: #fff;
    border-color: var(--brand-primary);
    box-shadow: var(--shadow-input-focus);
}

.select-wrapper {
    position: relative;
}

.select-wrapper::after {
    content: '\\f107';
    font-family: 'FontAwesome';
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--text-muted);
    pointer-events: none;
}

.error-banner {
    background-color: #FEF2F2;
    border: 1px solid #FECACA;
    color: var(--error);
    padding: 12px;
    border-radius: var(--radius-input);
    font-size: 0.9rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 16px;
}

.success-state {
    text-align: center;
    animation: fadeIn 0.5s ease;
}

.success-icon {
    width: 72px;
    height: 72px;
    background-color: #DCFCE7;
    color: #16A34A;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    margin: 0 auto 20px auto;
}

.success-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 24px;
}

.btn-secondary {
    background-color: transparent;
    border: 2px solid var(--border-light);
    color: var(--text-muted);
    font-weight: 600;
    padding: 14px;
    border-radius: var(--radius-input);
    cursor: pointer;
    transition: var(--transition);
    width: 100%;
}

.btn-secondary:hover {
    border-color: var(--brand-primary);
    color: var(--brand-primary);
    background-color: #fff;
}

.back-floating {
    position: absolute;
    top: 20px;
    left: 20px;
    background: white;
    border: none;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-main);
    transition: var(--transition);
    z-index: 10;
}

.back-floating:hover {
    transform: scale(1.1);
    color: var(--brand-primary);
}

@media (max-width: 600px) {
    .register-page-wrapper {
        padding: 0;
        justify-content: flex-start;
    }

    .auth-card.register-card {
        box-shadow: none;
        height: 100%;
        border-radius: 0;
        padding-top: 60px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth/Register.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;IAChC,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,kCAAkC;IAClC,eAAe;IACf,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,qCAAqC;IACrC,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,kCAAkC;IAClC,eAAe;IACf,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;IACrB;AACJ","sourcesContent":[".register-page-wrapper {\n    min-height: 100vh;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: var(--bg-page);\n    background-size: cover;\n    padding: 30px 20px 40px;\n}\n\n.auth-card.register-card {\n    max-width: 500px;\n}\n\n.register-header {\n    text-align: center;\n    margin-bottom: 24px;\n}\n\n.register-header h2 {\n    font-size: 1.75rem;\n    font-weight: 800;\n    color: var(--text-main);\n    margin: 0 0 8px 0;\n}\n\n.register-header p {\n    color: var(--text-muted);\n    font-size: 0.95rem;\n}\n\n.register-form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.name-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n}\n\ninput[type=\"email\"] {\n    text-transform: lowercase;\n}\n\n@media (max-width: 480px) {\n    .name-row {\n        grid-template-columns: 1fr;\n    }\n}\n\n.form-group input,\n.form-group select {\n    width: 100%;\n    height: 52px;\n    padding: 0 16px;\n    background-color: var(--bg-input);\n    border: 1px solid var(--border-light);\n    border-radius: var(--radius-input);\n    font-size: 1rem;\n    color: var(--text-main);\n    transition: var(--transition);\n    box-sizing: border-box;\n    appearance: none;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n    outline: none;\n    background-color: #fff;\n    border-color: var(--brand-primary);\n    box-shadow: var(--shadow-input-focus);\n}\n\n.select-wrapper {\n    position: relative;\n}\n\n.select-wrapper::after {\n    content: '\\f107';\n    font-family: 'FontAwesome';\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--text-muted);\n    pointer-events: none;\n}\n\n.error-banner {\n    background-color: #FEF2F2;\n    border: 1px solid #FECACA;\n    color: var(--error);\n    padding: 12px;\n    border-radius: var(--radius-input);\n    font-size: 0.9rem;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-bottom: 16px;\n}\n\n.success-state {\n    text-align: center;\n    animation: fadeIn 0.5s ease;\n}\n\n.success-icon {\n    width: 72px;\n    height: 72px;\n    background-color: #DCFCE7;\n    color: #16A34A;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 32px;\n    margin: 0 auto 20px auto;\n}\n\n.success-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 24px;\n}\n\n.btn-secondary {\n    background-color: transparent;\n    border: 2px solid var(--border-light);\n    color: var(--text-muted);\n    font-weight: 600;\n    padding: 14px;\n    border-radius: var(--radius-input);\n    cursor: pointer;\n    transition: var(--transition);\n    width: 100%;\n}\n\n.btn-secondary:hover {\n    border-color: var(--brand-primary);\n    color: var(--brand-primary);\n    background-color: #fff;\n}\n\n.back-floating {\n    position: absolute;\n    top: 20px;\n    left: 20px;\n    background: white;\n    border: none;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-main);\n    transition: var(--transition);\n    z-index: 10;\n}\n\n.back-floating:hover {\n    transform: scale(1.1);\n    color: var(--brand-primary);\n}\n\n@media (max-width: 600px) {\n    .register-page-wrapper {\n        padding: 0;\n        justify-content: flex-start;\n    }\n\n    .auth-card.register-card {\n        box-shadow: none;\n        height: 100%;\n        border-radius: 0;\n        padding-top: 60px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
